import { lazy } from "react";
import { ALLOWED_CITY_SLUGS } from "./cityRoute";

const ApplianceCityPage = lazy(() => import("../pages/appliance/page"));

export const APPLIANCE_CITY_ROUTE_STATIC = "-repair-in-";

export const ALLOWED_APPLIANCE_SLUGS = [
  "refrigerator",
  "freezer",
  "ice-maker",
  "wine-cooler",
  "dishwasher",
  "oven",
  "range",
  "stove",
  "cooktop",
  "microwave",
  "washer",
  "dryer",
] as const;

export type ApplianceSlug = (typeof ALLOWED_APPLIANCE_SLUGS)[number];

export const APPLIANCE_DISPLAY_NAMES: Record<ApplianceSlug, string> = {
  refrigerator: "Refrigerator",
  freezer: "Freezer",
  "ice-maker": "Ice Maker",
  "wine-cooler": "Wine Cooler",
  dishwasher: "Dishwasher",
  oven: "Oven",
  range: "Range",
  stove: "Stove",
  cooktop: "Cooktop",
  microwave: "Microwave",
  washer: "Washer",
  dryer: "Dryer",
};

const APPLIANCE_SLUG_SET = new Set(ALLOWED_APPLIANCE_SLUGS);
const CITY_SLUG_SET = new Set(ALLOWED_CITY_SLUGS);

export const isApplianceSlug = (value: string): value is ApplianceSlug => {
  return APPLIANCE_SLUG_SET.has(value as ApplianceSlug);
};

export const isCitySlug = (value: string): value is (typeof ALLOWED_CITY_SLUGS)[number] => {
  return CITY_SLUG_SET.has(value as (typeof ALLOWED_CITY_SLUGS)[number]);
};

export const APPLIANCE_CITY_PRERENDER_ENTRIES = ALLOWED_APPLIANCE_SLUGS.flatMap((appliance) =>
  ALLOWED_CITY_SLUGS.map((city) => {
    const slug = `${appliance}${APPLIANCE_CITY_ROUTE_STATIC}${city}`;
    return {
      url: `/${slug}`,
      params: {
        appliance,
        city,
      },
    };
  })
);

export const loadApplianceCityPage = (appliance: string, city: string) => {
  if (!isApplianceSlug(appliance) || !isCitySlug(city)) {
    return lazy(() => import("../pages/NotFound"));
  }

  return ApplianceCityPage;
};
